import React from 'react';
import { Page, Icon, Link, List, ListGroup, ListItem } from 'framework7-react';

export default function HelpPage() {
  return (
    <Page className='bg-white'>
      <div className="container container-table ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel">
                <Link href="#" back reloadAll><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon></Link>
                <h2>Help</h2>
              </div>
            </div>
          </header>
          <section className="pt-0 section-lg-b-space profile-form mt-3">
            <div className="custom-container p-0">
              <div className="categories-title pb-2">
                <h3>Help Page</h3>
                <p>Help.....</p>
              </div>          
            </div>
          </section>
        </div>
      </div>
    </Page>
  );
}
